<template>
    <div>
        <b-field 
            label="" 
            :class="{'is-marginless ':component.options.multiple === false}"
            :message="valid[component.name].valid === true?component.validation.errorMsg:component.display.description" 
            :type="valid[component.name].valid === true?'is-danger':''"
        >
            <b-upload drag-drop v-model="file" @input="uploadFile(component.name)" :multiple="component.options.multiple" class="form-upload width-max">
                <section class="pd-x-10">
                    <div class="align-center is-flex " >
                        <b-icon
                            pack="fas"
                            icon="file-upload"
                            custom-class="fa-cloud-upload-alt mg-x-5 has-text-grey-dark"
                        ></b-icon>
                        <p v-if="component.options.multiple === false && file !== null " class="mg-x-5">
                            <span                              
                            >{{file.name}}</span>
                        </p>
                        <p v-else class="mg-x-5 color-placeholder">
                            <span>{{component.display.placeholder}}</span>
                        </p>
                        <a class="button btn-upload icon-upload  mg-x-5 is-size-7">{{component.display.buttonText}}</a>
                    </div>
                </section>
            </b-upload>
        </b-field>
        <div v-if="component.options.multiple === false && statusFile !== null" class="has-text-right">
            <span v-if="statusFile == 0" class="is-size-7 th has-text-danger">อัพโหลดไฟล์ล้มเหลว</span>
            <span v-if="statusFile == 1" class="is-size-7 th has-text-success">อัพโหลดไฟล์สำเร็จ</span>
            <span v-if="statusFile == 2" class="is-size-7 th">กำลังอัพโหลดไฟล์....</span>
        </div>
        <div v-if="component.options.multiple === true" class="tags">
            <span v-for="(item, index) in file"
                :key="index"
                class="tag is-primary" >
                {{item.name}}
                <button class="delete is-small"
                    type="button"
                    @click="deleteFile(index)">
                </button>
            </span>
        </div>
    </div>
</template>
<script>
import {HTTPDynamic } from "@/service/axios";
export default {
    props:['component','input','fileUpload','delFile','value','componentsIndex','componentDataIndex','stepIndex','valid','ownedId'],
    data() {
        return {
            file:null,
            statusFile:null,
            oldFile:[]
        }
    },
    created() {
        setTimeout(() => {
            if (this.component.options.multiple === true) {
                this.file= JSON.parse(JSON.stringify(this.value))
            }else{
                let value =(this.value === null || typeof this.value.length=== 'undefined')?this.value:(this.value.length > 0)?this.value[0]:null
                this.file = JSON.parse(JSON.stringify(value))
            }
            
        }, 1000);
       
    },
    computed: {
        user(){
            return this.$store.state.user
        }
    },
    methods: {
        async uploadFile(name){

       
            const formData = new FormData();

            if (this.component.options.multiple === true) {
                formData.append("file", this.file[this.file.length-1]);
            }else{
                formData.append("file", this.file);
                this.statusFile = 2
                this.delFile.push(this.input[this.component.name])
            }

            if (typeof this.$route.params.roleId !== 'undefined' && this.$route.params.roleId !== '') {
                formData.append("companyId", this.$route.params.roleId);
                formData.append("aceUserId", this.$route.params.roleId);
            } else {
                formData.append("companyId", this.user._id);
                formData.append("aceUserId", this.user._id);
            }
 

            HTTPDynamic.defaults.headers.common.Authorization = `Bearer ${this.user.token}`; 
            await HTTPDynamic.post(`upload/file`,formData)
            .then(res => {
                console.log("upload/file", this.$route.params.roleId,formData,res);  
                if (res.data.success) {
                    this.setfileName(res.data.obj,this.component.options.multiple)
                    this.$emit('checkValidateRequired',this.valid[name].name,this.valid[name].validation)
                    
                }else{
                     this.$buefy.dialog.alert('<p class="has-text-centered is-size-5">อัพโหลดไฟล์ล้มเหลว</p>');
                    if (this.component.options.multiple === false) {
                        this.statusFile = 0
                    }
                }
            })
            .catch(e => {
                console.log("upload/file/error",e);
                if (this.component.options.multiple === false) {
                    this.statusFile = 0
                }
                 this.$buefy.dialog.alert('<p class="has-text-centered is-size-5">อัพโหลดไฟล์ล้มเหลว</p>');
            });
        },
        deleteFile(index){
            
            this.delFile.push(this.input[this.component.name][index])
            this.file.splice(index, 1)
            this.input[this.component.name].splice(index, 1)
           
        },
        setfileName(nameFile,status){
            if (status === true) {
                console.log('sdfksdlfsdkf')
               this.input[this.component.name].push({name:nameFile}) 
            }else{
                //console.log("nameFile",this.input[this.component.name])
                this.input[this.component.name] = {name:nameFile}
                this.statusFile = 1
            }
            
        }
    },
}
</script>
<style scoped>

</style>
